// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { getShipTosDataView } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import DataTable, { SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { tableProps } from "@store/Themes/common/props/table";
import addStoreList from "@store/Framework/Store/Pages/StoreLists/Handlers/AddStoreList";
import addSelectedShipTos from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/addSelectedShipTos";
import updateCustomersPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateCustomersPagination";
import updateShipTosPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateShipTosPagination";
import { StoreListCustomerModel } from "@store/Framework/Types/ApiModels";
import StoreListsShipTosPagination from "@store/Library/Components/StoreListsDetails/StoreListsShipTosPagination";
import cloneDeep from "lodash/cloneDeep";
import * as React from "react";
import { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    shipTosParameter: GetShipTosApiParameter;
    customerList?: StoreListCustomerModel[] | null;
    closeModalHandler: () => void;
    isCheckout?: boolean;
    checkoutStoreListName?: string;
    checkoutStoreListId?: string;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const location = getLocation(state);
    const parsedQuery = parseQueryString<{ listId?: string }>(location.search);
    const id = parsedQuery.listId;
    return {
        shipTosDataView: getShipTosDataView(state, props.shipTosParameter),
        storeListId: id,
    };
};

const mapDispatchToProps = {
    loadShipTos,
    addSelectedShipTos,
    updateShipTosPagination,
    addStoreList,
    updateCustomersPagination,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface StoreListsDetailsShipTosListStyles {
    shipTosTableWrapper?: InjectableCss;
}

export const shipTosListStyles: StoreListsDetailsShipTosListStyles = {
    shipTosTableWrapper: tableProps.wrapper,
};

const styles = shipTosListStyles;

export const StoreListsDetailsShipTosList: FC<Props> = ({
    shipTosParameter,
    customerList,
    closeModalHandler,
    shipTosDataView,
    storeListId,
    loadShipTos,
    addSelectedShipTos,
    updateShipTosPagination,
    isCheckout,
    checkoutStoreListId,
    checkoutStoreListName,
    addStoreList,
    updateCustomersPagination,
}) => {
    useEffect(() => {
        updateCustomersPagination({ storeListId: storeListId || checkoutStoreListId || "" });
        updateShipTosPagination(shipTosParameter);
    }, [storeListId, checkoutStoreListId]);

    useEffect(() => {
        if (!shipTosDataView.value && !shipTosDataView.isLoading) {
            loadShipTos(shipTosParameter);
        }
    }, [shipTosParameter]);

    const [shipToRows, setShipToRows] = useState<StoreListCustomerModel[]>();
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [hasSelectedStores, setHasSelectedStores] = useState(false);

    useEffect(() => {
        const selectedStores = shipToRows?.filter(shipTo => shipTo.isSelected);
        if (selectedStores && selectedStores.length > 0) {
            setHasSelectedStores(true);
        }
    }, [shipToRows]);

    useEffect(() => {
        setIsAllSelected(false);
        if (shipTosDataView.value) {
            const rows = shipTosDataView.value.map(shipTo => {
                return {
                    id: shipTo.id,
                    customerNumber: shipTo.customerNumber,
                    customerSequence: shipTo.customerSequence,
                    address: shipTo.address1,
                    city: shipTo.city,
                    customerName: shipTo.customerName,
                    uri: "",
                    properties: {},
                    isSelected: customerList?.some(customer => customer.customerSequence === shipTo.customerSequence),
                };
            });
            setShipToRows(rows);
        }
    }, [shipTosDataView.value]);

    const selectShipToChangeHandler = (value: boolean, index: number) => {
        if (shipToRows) {
            const currentShipToCollection = cloneDeep(shipToRows);
            currentShipToCollection[index].isSelected = value;
            setShipToRows(currentShipToCollection);
        }
    };

    const addSelectedStoreClickHandler = () => {
        const selectedStores = shipToRows?.filter(shipTo => shipTo.isSelected);

        if (selectedStores && selectedStores.length > 0) {
            if (isCheckout) {
                if (!checkoutStoreListId && checkoutStoreListName) {
                    addStoreList({
                        apiParameter: { name: checkoutStoreListName, description: "", temporary: true },
                        onSuccess: addedStoreList => {
                            addSelectedShipTos({
                                apiParameter: {
                                    storeListId: addedStoreList.id,
                                    storeListCustomerList: selectedStores,
                                },
                            });
                        },
                        onError: () => {},
                        onComplete(resultProps) {},
                    });
                } else if (checkoutStoreListId) {
                    addSelectedShipTos({
                        apiParameter: {
                            storeListId: checkoutStoreListId,
                            storeListCustomerList: selectedStores,
                        },
                    });
                }
            } else if (storeListId && selectedStores) {
                addSelectedShipTos({
                    apiParameter: {
                        storeListId,
                        storeListCustomerList: selectedStores,
                    },
                });
            }
            closeModalHandler();
        }
    };

    const selectAllChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        setIsAllSelected(value);
        if (shipToRows) {
            const rows = cloneDeep(shipToRows);
            rows.forEach(row => {
                row.isSelected = value;
            });
            setShipToRows(rows);
        }
    };

    const shipToHeaderClick = (sortField: string) => {
        const sort = shipTosParameter.sort === sortField ? `${sortField} DESC` : sortField;
        updateShipTosPagination({ ...shipTosParameter, sort });
    };

    const sorted = (sortField: string) => {
        let sorted: boolean | string = false;
        if (shipTosParameter.sort === sortField) {
            sorted = "ascending";
        } else if (shipTosParameter.sort === `${sortField} DESC`) {
            sorted = "descending";
        }
        return sorted as SortOrderOptions;
    };
    if (shipTosDataView.isLoading) {
        return (
            <StyledWrapper>
                <LoadingSpinner />
            </StyledWrapper>
        );
    }

    if (!shipToRows) {
        return <></>;
    }

    return (
        <>
            <StyledWrapper {...styles.shipTosTableWrapper}>
                <DataTable>
                    <DataTableHead>
                        <DataTableHeader>
                            <Checkbox
                                checked={isAllSelected}
                                onChange={selectAllChangeHandler}
                                data-test-selector="selectAllItems"
                                disabled={shipToRows.length === 0}
                            ></Checkbox>
                        </DataTableHeader>
                        <DataTableHeader
                            sorted={sorted("customerSequence")}
                            onSortClick={() => shipToHeaderClick("customerSequence")}
                        >
                            {translate("Id")}
                        </DataTableHeader>
                        <DataTableHeader
                            sorted={sorted("companyName")}
                            onSortClick={() => shipToHeaderClick("companyName")}
                        >
                            {translate("Customer")}
                        </DataTableHeader>
                        <DataTableHeader sorted={sorted("address1")} onSortClick={() => shipToHeaderClick("address1")}>
                            {translate("Address")}
                        </DataTableHeader>
                        <DataTableHeader sorted={sorted("city")} onSortClick={() => shipToHeaderClick("city")}>
                            {translate("City")}
                        </DataTableHeader>
                    </DataTableHead>
                    <DataTableBody>
                        {shipToRows.length ? (
                            shipToRows.map((shipTo, index) => (
                                <DataTableRow key={shipTo.id}>
                                    <DataTableCell aria-label={translate("Select Ship To")}>
                                        <Checkbox
                                            checked={shipTo.isSelected}
                                            onChange={(e, value) => selectShipToChangeHandler(value, index)}
                                        ></Checkbox>
                                    </DataTableCell>
                                    <DataTableCell>{shipTo.customerSequence}</DataTableCell>
                                    <DataTableCell>{shipTo.customerName}</DataTableCell>
                                    <DataTableCell>{shipTo.address}</DataTableCell>
                                    <DataTableCell>{shipTo.city}</DataTableCell>
                                </DataTableRow>
                            ))
                        ) : (
                            <DataTableRow>
                                <DataTableCell colSpan={5}>{translate("There were no results found.")}</DataTableCell>
                            </DataTableRow>
                        )}
                    </DataTableBody>
                </DataTable>
            </StyledWrapper>
            {shipToRows.length ? (
                <>
                    <StoreListsShipTosPagination dataView={shipTosDataView}></StoreListsShipTosPagination>
                    <Button onClick={event => addSelectedStoreClickHandler()} disabled={!hasSelectedStores}>
                        {translate("Add Selected Stores")}
                    </Button>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreListsDetailsShipTosList);
